// extracted by mini-css-extract-plugin
module.exports = {"burger":"Burger_burger__25A7f","wrapper":"Burger_wrapper__2mrJl","burger--clicked":"Burger_burger--clicked__Bmq08"};